import 'twin.macro';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import ButtonExternal from 'components/Buttons/ExternalLink';
import Img from 'components/Img';

function Step({
  numero,
  text,
  children,
}: {
  numero: number;
  text: any;
  children?: React.ReactNode;
}) {
  const { t } = useTranslation(['common']);
  return (
    <div
      tw="pl-4 py-2 flex flex-col md:pl-0 md:pt-4 md:pb-0"
      aria-current="step"
    >
      <span tw="text-xs text-brand-intense font-bold tracking-wide uppercase">
        {t('common:components.extensionTuto.stepX', { nb: numero })}
      </span>
      <span>{text}</span>
      {children}
    </div>
  );
}

export function ExtensionTeetshTuto() {
  const { t } = useTranslation(['common']);
  return (
    <div tw="relative py-16 overflow-hidden">
      <div tw="relative px-4 sm:px-6 lg:px-8">
        <div tw="text-lg max-w-prose mx-auto">
          <h1>
            <span tw="block text-base text-center text-brand-intense font-semibold tracking-wide uppercase">
              {t('common:components.extensionTuto.tutorial')}
            </span>
            <span tw="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-neutral-intense sm:text-4xl">
              {t('common:components.extensionTuto.title')}
            </span>
          </h1>
        </div>
        <div tw="mt-6 prose prose-lg text-neutral-quiet mx-auto">
          <Step numero={1} text={t('common:components.extensionTuto.step1')}>
            <div tw="py-4">
              <ButtonExternal
                href={
                  'https://chrome.google.com/webstore/detail/extension-teetsh/gnjgaamgaemconoociecoiadohngkhmn?hl=fr'
                }
                intent="primary"
                large
                tw="no-underline"
              >
                {t('common:components.extensionTuto.installExtension')}
              </ButtonExternal>
            </div>
          </Step>
          <Step
            numero={2}
            text={
              <Trans i18nKey="common:components.extensionTuto.step2">
                __A__
              </Trans>
            }
          >
            <Img
              s3Path="/strapi-assets/Doc_Eleves_Capture1_4f2b5936ac.png"
              width={400}
            />
          </Step>
          <Step
            numero={3}
            text={
              <Trans i18nKey="common:components.extensionTuto.step3">
                __A__
              </Trans>
            }
          />
          <Step numero={4} text={t('common:components.extensionTuto.step4')}>
            <Img
              s3Path="/strapi-assets/Doc_Eleves_Capture2_cd5337b4c4.png"
              width={400}
            />
          </Step>
          <Step numero={5} text={t('common:components.extensionTuto.step5')} />
        </div>
      </div>
    </div>
  );
}
